<div class="breadcrumb-container">
  <!-- Botón de atrás -->
  <div *ngIf="showBackButton" class="back-button-section">
    <button 
      pButton 
      [icon]="backIcon"
      [label]="backLabel"
      class="p-button-text p-button-sm"
      (click)="goBack()"
      pTooltip="Volver a la página anterior"
      tooltipPosition="bottom">
    </button>
  </div>

  <!-- Breadcrumb -->
  <ul class="breadcrumb-list">
    <li *ngFor="let item of items; let last = last" 
        [class]="'breadcrumb-item' + (item.active ? ' active' : '') + (last ? ' last' : '')">
      
      <ng-container *ngIf="!last">
        <a *ngIf="item.route && !item.active" 
           [routerLink]="[item.route]" 
           class="breadcrumb-link">
          {{ item.label }}
        </a>
        <span *ngIf="!item.route || item.active" class="breadcrumb-text">
          {{ item.label }}
        </span>
      </ng-container>

      <ng-container *ngIf="last">
        <span class="breadcrumb-text active">{{ item.label }}</span>
      </ng-container>

      <!-- Separador -->
      <i *ngIf="!last" class="pi pi-angle-right separator"></i>
    </li>
  </ul>
</div> 